var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('populate-form',{ref:"filterForm",attrs:{"collapseStyle":"simple","formTitle":"店家核銷失敗紀錄","fkey":"tm01","populateOptionVar":"filterOptions","formDataObjVar":"filterData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }